import { render, staticRenderFns } from "./BalancePreview.vue?vue&type=template&id=3720a80a&"
import script from "./BalancePreview.vue?vue&type=script&lang=js&"
export * from "./BalancePreview.vue?vue&type=script&lang=js&"
import style0 from "./BalancePreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
